import { normalizarTexto } from '../../shared/utils/utils'

export interface ParadaItinerario {
  id?: string
  tarifarioId?: string
  ordem: number
  trecho?: string | null
  areaTarifario?: string | null
  localParada?: string | null
  descricao?: string | null
  cep?: string | null
  logradouro?: string | null
  numero?: string | null
  bairro?: string | null
  complemento?: string | null
  cidade?: string | null
  estado?: string | null
  latitude?: number | null
  longitude?: number | null
  horaParada?: string | null
  tempoPermanencia?: string | null
  atividades?: string | null
  dataCriacao?: string
  horaCriacao?: string
  criadoPor?: number
}

export class TarifarioForkRequest {
  public itemPropostaId?: number | string
  public paradas: ParadaItinerario[] = []
}

export interface TarifarioVm {
  id: string
  tipoId: number
  tipoTarifario?: string
  origemId: number
  origem?: string
  cidadeOrigem?: string
  estadoOrigem?: string
  paisOrigem?: string
  destinoId: number
  destino?: string
  cidadeDestino?: string
  estadoDestino?: string
  paisDestino?: string
  tipoServicoId: number
  tipoServico?: string
  servicoId: number
  servico?: string
  tipoVeiculoId?: number
  tipoVeiculo?: string
  tipoMotoristaId?: number
  tipoMotorista?: string
  fornecedorId?: number
  fornecedor?: string
  custo: number
  custoHoraExtra: number
  custokmExtra: number
  dataCriacao?: string
  horaCriacao?: string
  import?: string
  ativo: string
  dataValidade?: string
  clienteId?: number
  cliente?: string
  subCliente?: string
  usuarioId?: number
  login?: string
  pessoaId?: number
  usuario?: string
  perimetroUrbano?: string
  standard?: string
  paradas?: ParadaItinerario[]
}

export function paradaToItinerarioItemProposta(p: ParadaItinerario): any {
  return {
    localParada: p.localParada ?? '',
    descricao: p.localParada ?? '',
    cep: p.cep ?? '',
    logradouro: p.logradouro ?? '',
    numero: p.numero ?? '',
    bairro: p.bairro ?? '',
    complemento: p.complemento ?? '',
    cidade: p.cidade ?? '',
    estado: p.estado ?? '',
    latitude: p.latitude ?? null,
    longitude: p.longitude ?? null,
    trecho: p.trecho ?? 'P',
    areaTarifario: p.areaTarifario ?? 'N',
    horaParada: p.horaParada ?? '',
    tempoPermanencia: p.tempoPermanencia ?? '',
    atividades: p.atividades ?? '',
  }
}

// Token canônico "cidade|estado" — espelha TarifarioCidadesHelper.Token do backend
// (normaliza com NormalizarTexto: lowercase + trim + sem acento, espaços internos mantidos).
export function cidadeEstadoToken(
  cidade?: string | null,
  estado?: string | null,
): string {
  return `${normalizarTexto(cidade ?? '')}|${normalizarTexto(estado ?? '')}`
}

export function paradaCidadeEstadoToken(p: ParadaItinerario): string {
  return cidadeEstadoToken(p.cidade, p.estado)
}

// Espelha TarifarioCidadesHelper.MontarChaveCidades:
// - ordena por `ordem`;
// - token cidade+estado normalizado;
// - ignora paradas sem cidade/estado ("|");
// - considera TODAS as paradas (origem/destino também contam — sem neutralidade);
// - preserva ordem (NÃO deduplica nem reordena).
export function montarChaveCidades(paradas: ParadaItinerario[] = []): string[] {
  return [...(paradas ?? [])]
    .filter((p) => (p.trecho ?? 'P') === 'P')
    .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0))
    .map((p) => paradaCidadeEstadoToken(p))
    .filter((t) => t !== '|')
}

// Divergem quando a sequência ordenada de (cidade,estado) das paradas difere —
// a ordem conta, igual ao SequenceEqual do backend.
export function paradasDivergem(
  a: ParadaItinerario[],
  b: ParadaItinerario[],
): boolean {
  const chaveA = montarChaveCidades(a)
  const chaveB = montarChaveCidades(b)
  if (chaveA.length !== chaveB.length) return true
  for (let i = 0; i < chaveA.length; i++) {
    if (chaveA[i] !== chaveB[i]) return true
  }
  return false
}
